/** Tiny synthesised sound effects (no audio files) and haptics. Respect the player's settings. */
let ctx: AudioContext | null = null;
let enabled = true, haptics = true;
export const configureSfx = (o: { sound?: boolean; haptics?: boolean }) => { enabled = o.sound !== false; haptics = o.haptics !== false; };

function ac(): AudioContext | null {
  if (!enabled) return null;
  try { ctx ??= new (window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext)(); if (ctx.state === 'suspended') void ctx.resume(); return ctx; } catch { return null; }
}
function tone(freq: number, ms: number, type: OscillatorType = 'sine', gain = 0.08, slide?: number) {
  const c = ac(); if (!c) return;
  const o = c.createOscillator(), g = c.createGain();
  o.type = type; o.frequency.setValueAtTime(freq, c.currentTime);
  if (slide) o.frequency.exponentialRampToValueAtTime(slide, c.currentTime + ms / 1000);
  g.gain.setValueAtTime(gain, c.currentTime); g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + ms / 1000);
  o.connect(g).connect(c.destination); o.start(); o.stop(c.currentTime + ms / 1000);
}
const buzz = (pattern: number | number[]) => { if (haptics && 'vibrate' in navigator) try { navigator.vibrate(pattern); } catch { /* ignore */ } };

export const sfx = {
  unlock() { ac(); },
  draw() { tone(520, 90, 'triangle', 0.05, 780); },
  select() { tone(660, 60, 'square', 0.03); },
  tame(ok: boolean) { if (ok) { tone(440, 120, 'triangle', 0.08, 880); setTimeout(() => tone(880, 160, 'triangle', 0.08, 1320), 110); buzz(30); } else { tone(300, 220, 'sawtooth', 0.06, 120); buzz([20, 40, 20]); } },
  raid() { tone(200, 120, 'square', 0.07, 90); buzz(25); },
  kill() { tone(160, 260, 'sawtooth', 0.08, 50); buzz([40, 30, 60]); },
  tie() { tone(330, 150, 'triangle', 0.05); },
  level() { [523, 659, 784, 1047].forEach((f, i) => setTimeout(() => tone(f, 140, 'triangle', 0.07), i * 70)); buzz(50); },
  dice() { for (let i = 0; i < 8; i++) setTimeout(() => tone(900 + Math.random() * 600, 40, 'square', 0.03), i * 70); },
  coin() { tone(1200, 80, 'sine', 0.05, 1800); },
  turn() { tone(660, 120, 'sine', 0.06, 990); buzz(20); },
  win() { [523, 659, 784, 1047, 1319].forEach((f, i) => setTimeout(() => tone(f, 220, 'triangle', 0.08), i * 110)); buzz([60, 40, 60, 40, 120]); },
  lose() { [392, 349, 311, 262].forEach((f, i) => setTimeout(() => tone(f, 260, 'sawtooth', 0.05), i * 160)); buzz(200); },
  emote() { tone(880, 90, 'sine', 0.04, 1100); },
  error() { tone(180, 120, 'square', 0.05); buzz(60); },
};
